import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col" };
const _hoisted_2 = { class: "flex min-h-0 flex-1 flex-col border-r border-gray-200 bg-white" };
const _hoisted_3 = { class: "flex flex-1 flex-col overflow-y-auto pt-5 pb-4 mt-8" };
const _hoisted_4 = { class: "mt-5 flex-1 space-y-1 bg-white px-2" };
const _hoisted_5 = ["href", "onClick"];
const _hoisted_6 = { class: "flex flex-1 flex-col md:pl-64" };
const _hoisted_7 = { class: "flex-1" };
const _hoisted_8 = { class: "py-6" };
const _hoisted_9 = { class: "mx-auto max-w-7xl px-4 sm:px-6 md:px-8" };
const _hoisted_10 = { class: "md:hidden flex relative" };
const _hoisted_11 = { class: "text-2xl font-semibold text-gray-900" };
const _hoisted_12 = {
    key: 0,
    class: "absolute left-0 top-6 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
};
const _hoisted_13 = { class: "py-1" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "text-2xl font-semibold text-gray-900 hidden md:block" };
const _hoisted_16 = { class: "mx-auto max-w-7xl px-4 sm:px-6 md:px-8" };
const _hoisted_17 = { class: "py-4" };
import { AdjustmentsIcon, ChartBarIcon, ChevronDownIcon, PencilAltIcon, UsersIcon, } from '@heroicons/vue/outline';
import { computed, ref } from 'vue';
import ConfigManagement from '@/components/admin/admin-components/config/ConfigManagement.vue';
import H2rDashboard from '@/components/admin/admin-components/h2rDashboard/H2rDashboard.vue';
import ReportingDownload from '@/components/admin/admin-components/reporting/ReportingDownload.vue';
import UserManagement from '@/components/admin/admin-components/users/UserManagement.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdminPanel',
    setup(__props) {
        const dropdownOpen = ref(false);
        const navIndex = ref(0);
        const navigation = [
            { name: 'Users', icon: UsersIcon, component: UserManagement, index: 0 },
            {
                name: 'Config Items',
                icon: AdjustmentsIcon,
                component: ConfigManagement,
                index: 1,
            },
            {
                name: 'Reporting',
                icon: ChartBarIcon,
                component: ReportingDownload,
                index: 2,
            },
            {
                name: 'H2R Dashboard',
                icon: PencilAltIcon,
                component: H2rDashboard,
                index: 3,
            },
        ];
        const currentNavItem = computed(() => navigation.find((item) => item.index === navIndex.value));
        const toggleDropdown = () => {
            dropdownOpen.value = !dropdownOpen.value;
        };
        const handleNavClick = (index) => {
            navIndex.value = index;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("nav", _hoisted_4, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                                    return _createElementVNode("button", {
                                        key: item.name,
                                        class: _normalizeClass(["w-full", [item.name === currentNavItem.value.name ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center px-2 py-2 text-sm font-medium rounded-md']]),
                                        href: item.href,
                                        onClick: ($event) => (handleNavClick(item.index))
                                    }, [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                            class: _normalizeClass([item.name === currentNavItem.value.name ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 flex-shrink-0 h-6 w-6']),
                                            "aria-hidden": "true"
                                        }, null, 8, ["class"])),
                                        _createTextVNode(" " + _toDisplayString(item.name), 1)
                                    ], 10, _hoisted_5);
                                }), 64))
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("main", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("h1", _hoisted_11, _toDisplayString(currentNavItem.value.name), 1),
                                    _createTextVNode(),
                                    _createElementVNode("button", {
                                        class: "ml-2",
                                        onClick: toggleDropdown
                                    }, [
                                        _createVNode(_unref(ChevronDownIcon), {
                                            class: _normalizeClass(["h-6 w-6 text-gray-800 duration-100", { 'rotate-180 duration-100': dropdownOpen.value }])
                                        }, null, 8, ["class"])
                                    ]),
                                    _createTextVNode(),
                                    (dropdownOpen.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _createElementVNode("div", _hoisted_13, [
                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                                                    return _createElementVNode("button", {
                                                        key: item.index,
                                                        class: _normalizeClass(["w-full", [item.name === currentNavItem.value.name ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']]),
                                                        onClick: ($event) => (handleNavClick(item.index))
                                                    }, [
                                                        (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" })),
                                                        _createTextVNode(" " + _toDisplayString(item.name), 1)
                                                    ], 10, _hoisted_14);
                                                }), 64))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("h1", _hoisted_15, _toDisplayString(currentNavItem.value.name), 1)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(currentNavItem.value.component)))
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
